export default __webpack_public_path__ + "static/media/pavillion.8bae4957.svg";